export default __webpack_public_path__ + "static/media/agreement.4895db28.svg";